import React from 'react';

const FileUploadField = ({
  label,
  name,
  required,
  error,
  onChange,
  existingUrl,
  selectedFile,
}) => (
  <div className={`vo-form-group ${error ? 'has-error' : ''}`}>
    <label className={`vo-label ${required ? 'required' : ''}`}>{label}</label>
    <div className="vo-file-upload">
      <input
        type="file"
        name={name}
        id={name}
        className="vo-file-input"
        accept=".pdf,.png,.jpg,.jpeg,image/png,image/jpeg,application/pdf"
        onChange={(e) => onChange(name, e.target.files?.[0] || null)}
      />
      <label htmlFor={name} className="vo-file-btn">
        Choose file
      </label>
      <span className="vo-file-name">
        {selectedFile?.name ? (
          selectedFile.name
        ) : existingUrl ? (
          <a href={existingUrl} target="_blank" rel="noreferrer" className="vo-link">
            View attachment
          </a>
        ) : (
          'No file chosen'
        )}
      </span>
    </div>
    <small className="vo-hint">Accepted: PDF, PNG, JPG (max 5MB)</small>
    {error && <span className="vo-error">{error}</span>}
  </div>
);

export default FileUploadField;
